<template>
  <b-modal
    v-model="showModal"
    :title="title"
    modal-class="modal-primary"
    hide-footer
    @hidden="$emit('hidden')"
    size="xmd"
    no-close-on-backdrop
  >
    <b-alert
      show
      class="d-flex align-items-center p-1 mb-2 border-left border-primary small"
    >
      <feather-icon icon="InfoIcon" class="mr-1 text-primary" size="14" />
      <span>
        <strong>Reprogramación:</strong> Solo hasta
        <span class="text-primary font-weight-bold">
          3 días antes ({{ threeDaysAgo }}) </span
        >.
      </span>
    </b-alert>

    <b-row class="modal-reprogramar-vacaciones">
      <b-col cols="12">
        <b-table
          ref="vacaciones_programadas_table"
          sticky-header="70vh"
          hover
          :items="items"
          :fields="vacaciones_reprogramar_fields"
          show-empty
          empty-text="No hay vacaciones disponibles para reprogramar"
          responsive
          primary-key="id"
        >
          <template #cell(fecha)="data">
            <span v-if="!data.item.editable">{{ data.value | myGlobal }}</span>

            <b-form-datepicker
              v-else
              v-model="data.item.fecha"
              :min="tomorrow"
              :date-disabled-fn="(date) => fechasBloqueadas(date, data.item)"
              class="form-control"
              locale="es"
              :start-weekday="1"
            />
          </template>
          <template #cell(created_at)="data">
            <span>{{ data.value | myGlobalWithHour }}</span>
          </template>
          <template #cell(comprado)="data">
            <div class="d-flex justify-content-center">
              <span
                class="text-center"
                :class="data.value ? 'text-success' : 'text-danger'"
              >
                {{ data.value ? "SI" : "NO" }}
              </span>
            </div>
          </template>
          <template #cell(costo)="data">
            <div
              v-if="data.item.comprado && data.value"
              class="d-flex justify-content-center align-items-center"
            >
              <tabler-icon
                v-if="data.item.comprado == 1"
                icon="MoneybagIcon"
                :class="data.item.pagado ? 'text-success' : 'text-danger'"
                size="20"
                class="mr-1"
              />

              <span
                class="text-center"
                :class="data.item.pagado ? 'text-success' : 'text-danger'"
              >
                S/.{{ data.value | currencyZero }}
              </span>
            </div>
            <span v-else class="text-center">-</span>
          </template>
          <template #cell(actions)="data">
            <b-button
              size="sm"
              class="mr-1"
              variant="transparent"
              @click="destroy(data.item.id)"
            >
              <feather-icon icon="Trash2Icon" class="text-danger" size="16" />
            </b-button>
            <!-- v-b-tooltip.hover.title="
                data.item.fecha < today
                  ? 'No se puede reprogramar una fecha pasada'
                  : 'Reprogramar fecha'
              " -->
            <!-- :disabled="data.item.fecha < today" -->

            <span>
              <b-button
                v-if="!data.item.editable"
                size="sm"
                variant="transparent"
                class="mr-1"
                @click="enableEdit(data.item.id)"
              >
                <feather-icon
                  icon="CalendarIcon"
                  class="text-warning"
                  size="16"
                />
              </b-button>
            </span>

            <b-button
              v-if="data.item.editable"
              size="sm"
              variant="transparent"
              @click="disableEdit(data.item.id)"
            >
              <feather-icon icon="XIcon" class="text-danger" size="16" />
            </b-button>

            <b-button
              v-if="
                data.item.editable && data.item.fecha !== data.item.originalDate
              "
              size="sm"
              @click="reprogramar(data.item.id, data.item.fecha)"
              variant="transparent"
            >
              <feather-icon icon="CheckIcon" class="text-success" size="16" />
            </b-button>
          </template>
        </b-table>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import VacacionesService from "@/views/rrhh/views/payroll/components/vacaciones/service/vacaciones.service.js";
import { vacaciones_reprogramar_fields } from "@/views/rrhh/views/payroll/components/vacaciones/data/vacaciones.programadas.fields.js";
export default {
  props: {
    idPersonal: {
      type: Number,
      require: true,
    },
  },
  components: {
    ToastificationContent,
  },
  data() {
    return {
      vacaciones_reprogramar_fields,
      showModal: true,
      items: [],
      empleado: {
        empleado: "",
      },
      tomorrow: new Date(new Date().setDate(new Date().getDate() - 3)), // para que se pueda reprogramar hasta 3 dias atras al dia de hoy
    };
  },
  computed: {
    title() {
      return `REPROGRAMAR VACACIONES: ${this.empleado.empleado}`;
    },
    today() {
      const hoy = new Date();
      const year = hoy.getFullYear();
      const month = String(hoy.getMonth() + 1).padStart(2, "0");
      const day = String(hoy.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
    threeDaysAgo() {
      const date = new Date();
      date.setDate(date.getDate() - 3);
      const y = date.getFullYear();
      const m = String(date.getMonth() + 1).padStart(2, "0");
      const d = String(date.getDate()).padStart(2, "0");
      return `${y}-${m}-${d}`;
    },
  },
  mounted() {
    this.index();
    this.show();
  },
  methods: {
    async index() {
      try {
        this.addPreloader();
        const { data } =
          await VacacionesService.getVacacionesProgramadasPorEmpleado({
            id_personal: this.idPersonal,
          });

        data.forEach((item) => {
          item.editable = false;

          // Copia el string si es string, o haz una copia del objeto Date si es Date
          item.originalDate =
            typeof item.fecha === "string"
              ? item.fecha
              : new Date(item.fecha.getTime());
        });

        // Obtener la fecha actual y restarle 3 días
        const currentDate = new Date();
        currentDate.setHours(0, 0, 0, 0);
        currentDate.setDate(currentDate.getDate() - 4); // restar 3 días para permitir reprogramar hasta 3 días atrás (es solo para listar en la tabla)

        // const filteredData = data.filter((item) => {
        //   const itemDate = new Date(item.fecha);
        //   return itemDate >= currentDate;
        // });

        // this.items = filteredData;

        this.items = data;
        // IMPORTANTE: convertir cada fecha en Date y normalizar a medianoche
        this.disabledDatesArray = data.map((item) => {
          const date = new Date(item.fecha);
          date.setHours(0, 0, 0, 0); // normaliza la hora
          return date;
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.removePreloader();
      }
    },
    fechasBloqueadas(date, itemActual) {
      const fechaSeleccionada = new Date(itemActual.fecha);
      fechaSeleccionada.setHours(0, 0, 0, 0);
      const isoSeleccionada = fechaSeleccionada.toISOString().split("T")[0];

      const fechasBloqueadas = this.items
        .map((item) => {
          const f = new Date(item.fecha);
          f.setHours(0, 0, 0, 0);
          return f.toISOString().split("T")[0];
        })
        .filter((iso) => iso !== isoSeleccionada);

      const d = new Date(date);
      d.setHours(0, 0, 0, 0);
      const isoDate = d.toISOString().split("T")[0];

      return fechasBloqueadas.includes(isoDate);
    },
    async show() {
      try {
        this.addPreloader();
        const { data } = await VacacionesService.getDataProgramarVacaciones({
          id: this.idPersonal,
        });
        this.empleado = data.empleado;
      } catch (error) {
        console.error(error);
      } finally {
        this.removePreloader();
      }
    },
    async destroy(id) {
      try {
        const { isConfirmed } = await this.showConfirmSwal();

        if (!isConfirmed) {
          return;
        }

        this.addPreloader();
        const { data } = await VacacionesService.destroy({
          id,
        });

        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Éxito",
            icon: "CheckIcon",
            variant: "success",
            text: data.message,
          },
        });
        this.index();
      } catch (error) {
        console.error(error);
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: "Error",
            icon: "XIcon",
            variant: "danger",
            text: "Error al programar las vacaciones.",
          },
        });
      } finally {
        this.removePreloader();
      }
    },

    async reprogramar(id, fecha) {
      try {
        const { isConfirmed } = await this.showConfirmSwal(
          "¿Estás seguro de que deseas reprogramar las vacaciones?"
        );

        if (!isConfirmed) {
          return;
        }

        let params = {
          id,
          fecha: fecha,
        };

        this.addPreloader();
        const { data } = await VacacionesService.reprogramarVacaciones(params);

        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Éxito",
            icon: "CheckIcon",
            variant: "success",
            text: data.message,
          },
        });
        this.index();
      } catch (error) {
        console.error(error);
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: "Error",
            icon: "XIcon",
            variant: "danger",
            text: "Error al reprogramar las vacaciones.",
          },
        });
      } finally {
        this.removePreloader();
      }
    },
    enableEdit(id) {
      this.items.forEach((item) => {
        if (item.editable) {
          item.editable = false;

          // Restaurar fecha original (Date o string, según tipo inicial)
          item.fecha =
            typeof item.originalDate === "string"
              ? item.originalDate
              : new Date(item.originalDate.getTime());
        }
      });

      const item = this.items.find((item) => item.id === id);
      if (item) {
        item.editable = true;
      }
    },
    disableEdit(id) {
      const item = this.items.find((item) => item.id === id);
      if (item) {
        item.editable = false;

        // Restaurar fecha original (Date o string, según tipo inicial)
        item.fecha =
          typeof item.originalDate === "string"
            ? item.originalDate
            : new Date(item.originalDate.getTime());
      }
    },
  },
};
</script>